import { InputDate, InputTime } from "./date-time";
import Description from "./Description";
import ErrorMessage from "./ErrorMessage";
import Input from "./Input";
import { InputNumber } from "./input-number";
import { InputTags } from "./input-tags";
import Label from "./Label";
import Password from "./Password";
import Root from "./Root";
import Textarea from "./Textarea";

export const TextField = {
  Root,
  Input,
  InputNumber,
  InputTime,
  InputDate,
  InputTags,
  Password,
  Textarea,
  Label,
  Description,
  ErrorMessage,
};

export { type TextFieldInputDateProps, type TextFieldInputTimeProps } from "./date-time";
export { type TextFieldDescriptionProps } from "./Description";
export { type TextFieldErrorMessageProps } from "./ErrorMessage";
export { type TextFieldInputProps } from "./Input";
export { type InputNumberBlurEvent, type InputNumberBlurTarget, type TextFieldInputNumberProps } from "./input-number";
export { type TextFieldLabelProps } from "./Label";
export { type TextFieldPasswordProps } from "./Password";
export { type TextFieldRootProps } from "./Root";
export { type TextFieldTextareaProps } from "./Textarea";
